import { Avatar } from "../avatar/Avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "../dropdownMenu/DropdownMenu";
import { Icon, IconProps } from "../icon/Icon";
import { ThemeSwitcher } from "../themeSwitcher/ThemeSwitcher";
import {
  avatarAndName,
  avatarStyle,
  itemIcon,
  nameStyle,
  userMenuTrigger
} from "./UserMenu.css";

interface UserMenuProps {
  items: {
    /**
     * The label of the menu item
     */
    label: string;

    /**
     * Optional icon to display next to the label.
     */
    icon?: IconProps["name"];

    /**
     * Optional onClick handler for the menu item.
     */
    onClick?: () => void;
  }[];

  /**
   * The name of the user to display in the menu.
   */
  userName: string;

  /**
   * URL of the user's profile image.
   */
  imageUrl?: string;
}

export function UserMenu({ items, userName, imageUrl }: UserMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className={userMenuTrigger}>
        <div className={avatarAndName}>
          <div className={avatarStyle}>
            <Avatar userName={userName} src={imageUrl} />
          </div>
          <span className={nameStyle}>{userName}</span>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent aria-describedby="dialog-content">
        {items.map((item, index) => (
          <DropdownMenuItem
            key={index}
            onSelect={() => {
              item.onClick?.();
            }}
          >
            {item.icon ? (
              <span className={itemIcon}>
                <Icon name={item.icon} />
              </span>
            ) : undefined}
            {item.label}
          </DropdownMenuItem>
        ))}
        <ThemeSwitcher />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
